import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { supabase } from './lib/supabase';
import { migrateLegacySession } from './shared/sessionMigration';
import './index.css';

// One-time bridge: adopt a pre-cookie localStorage session so the storage
// move signs nobody out. Fire-and-forget — if it lands after first render,
// AuthContext picks it up via onAuthStateChange. Never throws.
void migrateLegacySession(supabase);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
